var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,51.49l16.12-8.39-9.49-12.59,13.91,7.07,3.31-14.79,3.31,14.79,13.47-7.07-9.05,12.81,16.12,8.39-17-.88,2.87,13.69,.66,2.87-1.77-2.43-8.61-11.26-10.38,13.47,3.53-16.56-17,.88Zm27.16,36.21l4.64-6.4-6.84,3.53-1.77-7.51-1.77,7.51-6.62-3.53,4.64,6.4-8.17,4.19,8.83-.44-1.77,8.39,5.08-6.84,4.2,5.52,.88,1.1-.22-1.32-1.55-6.84,8.61,.44-8.17-4.19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.1e712fa7.svg";
export { ForwardRef as ReactComponent };